import React from 'react';
import { theme } from '../theme';

// ─── TriStateControl ────────────────────────────────────
export const TriStateControl: React.FC<{
  options: { value: string; label: string }[];
  selected: string;
  onChange: (value: string) => void;
  size?: 'sm' | 'md';
}> = ({ options, selected, onChange, size = 'sm' }) => {
  const isSm = size === 'sm';
  return (
    <div style={{
      display: 'inline-flex', borderRadius: theme.borderRadius.sm,
      border: `1px solid ${theme.colors.borderLight}`, overflow: 'hidden',
    }}>
      {options.map(opt => {
        const isActive = opt.value === selected;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            style={{
              border: 'none', cursor: 'pointer',
              padding: isSm ? '2px 8px' : '4px 12px',
              fontSize: isSm ? 11 : 12,
              fontWeight: 500,
              fontFamily: theme.font.family,
              color: isActive ? theme.colors.white : theme.colors.navyMid,
              backgroundColor: isActive ? theme.colors.navy : theme.colors.white,
              transition: 'background-color 0.15s ease, color 0.15s ease',
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};
